import HttpClient from "@/common/boot/HttpClient"

const listarProcessos = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-processos', payload).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
}

const listarProcessosGestaoProducao = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
    await HttpClient.get('/gestao-producao/processos', payload).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
}

const listarTipoAgings = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/ctrl-tipos-agings', payload).then(response => {
    commit('LISTAR_DADOS_TIPOS_AGINGS', response.data.data);
    return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const listarMacroProcessos = ({ commit, getters }, payload) => {
  let dados = getters.listaDeProcessos;

  if(typeof payload != 'undefined'){
    dados = dados.filter(item => item.id != payload.id);
  }
  
  commit('LISTAR_MACRO_PROCESSOS', dados);
} 

const listarMacroProcessosEP = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-processos/macro-processos', payload).then(response => {
        commit('LISTAR_MACRO_PROCESSOS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
} 

const listarProcessosHierarquias = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-processos-hierarquias', payload).then(response => {
        commit('LISTAR_PROCESSOS_HIERARQUIAS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
}

const excluirProcessos = async ({ commit, dispatch },  payload) => { 
  commit('CARREGANDO', true);
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
   
    await dispatch('listarProcessos');

    commit('CARREGANDO', false);
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-processos/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarProcesso = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-processos', payload).then(response => {
    dispatch('listarProcessos');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarProcesso = ({ commit, state }, payload) => {

  commit('CARREGANDO', true);

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_PROCESSO_SELECIONADO', ...item);
    return true;
  }

  commit('CARREGANDO', false);

  return false;
}

const atualizarProcesso = async ({ commit,dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-processos/${payload.id}`, payload).then(response => {
    dispatch('listarProcessos');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

export {
  listarProcessos,
  listarProcessosGestaoProducao,
  listarTipoAgings,
  excluirProcessos,
  salvarProcesso,
  recuperarProcesso,
  atualizarProcesso,
  listarMacroProcessos,
  listarMacroProcessosEP,
  listarProcessosHierarquias
}